import { createContext, useContext } from "react";
import type { ModuleId } from "@/modules";
import type { ChatAttachment } from "../types";

/** Yeni oluşturulan konuşmanın ilk mesajı — stream'i başlatan taraf tüketir. */
export interface ChatPendingMessage {
  chatId: string;
  message: string;
  attachments?: ChatAttachment[];
}

export interface ChatScope {
  /**
   * page — /chat/:id tam sayfa; breadcrumb, başlık ve URL doğrulaması çalışır.
   * dock — modül sağ paneli; sayfa efektleri yok, kimlik route'tan gelmez.
   */
  surface: "page" | "dock";
  /**
   * Dock daraldığında balonlar %100 olur. Tam sayfada undefined/false —
   * mevcut max-w yerleşimi değişmez.
   */
  compactBubbles?: boolean;
  chatId: string | null;
  /**
   * Konuşmanın yürütüldüğü modül (yalnızca dock). Stream isteğine
   * `module`/`agentId` olarak gider; backend yeni ya da modülsüz konuşmayı
   * bununla damgalar, modülü olanı asla taşımaz. Tam sayfada boş: /chat/:id
   * genel asistanın yüzeyidir, modüllü sohbetin modülü zaten sunucuda.
   */
  module?: ModuleId;
  /** İlk mesaj (yalnızca dock; page'de location.state taşır). */
  pending?: ChatPendingMessage | null;
  /** Pending tüketildi — ikinci kez gönderilmesin. */
  consumePending?: () => void;
}

/**
 * Chat motorunun "hangi konuşmadayım" sorusuna route dışından cevap veren
 * katman. Provider yoksa `useCurrentChatId` route param'ına düşer; yani
 * mevcut /chat/:id sayfası bu context'i hiç görmeden bugünkü gibi çalışır.
 *
 * Bu dosya bilerek bağımsız (yalnızca react + type import'lar): `@/hooks` buradan
 * import eder, `@/features/chat` de `@/hooks`'u kullanır — barrel üzerinden
 * gidilse döngü oluşurdu.
 */
export const ChatScopeContext = createContext<ChatScope | null>(null);

export const useChatScope = (): ChatScope | null => useContext(ChatScopeContext);
